import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { resolveImageUrl } from "@/components/ImageUploader";

export default function ImageGallery({ images = [] }) {
  const [idx, setIdx] = useState(0);
  if (!images.length) return null;
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);
  return (
    <div className="relative rounded-2xl overflow-hidden bg-cream-200" data-testid="poi-gallery">
      <div className="aspect-[4/3] w-full">
        <img
          key={idx}
          src={resolveImageUrl(images[idx])}
          alt=""
          className="w-full h-full object-cover animate-fade-up"
          loading="lazy"
        />
      </div>
      {images.length > 1 && (
        <>
          <button
            onClick={prev}
            data-testid="gallery-prev"
            aria-label="Previous"
            className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/85 backdrop-blur flex items-center justify-center text-ink-900 shadow-md active:scale-95 transition"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button
            onClick={next}
            data-testid="gallery-next"
            aria-label="Next"
            className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/85 backdrop-blur flex items-center justify-center text-ink-900 shadow-md active:scale-95 transition"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {images.map((_, i) => (
              <span
                key={i}
                className={cn(
                  "block h-1.5 rounded-full transition-all",
                  i === idx ? "w-5 bg-white" : "w-1.5 bg-white/60"
                )}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
